import React from 'react';
import '../../style/inDevelopment.css';
const gaikuoditu = require('../../assets/gaikuoditu.jpg');

function InDevelopment() {
    return (
        <div className="inDevelopment">
            <div className="inDevelopment-text">
                <div className="inDevelopment-text__title">
                    产业发展概况
                </div>
                <div className="inDevelopment-text__body">
                    <p className="inDevelopment-text__body--text">
                         <span className="inDevelopment-text__body--text__t">(一) 新奇特优热带特色农业</span>育才生态区位于北纬18°26′属热带海洋季风气候，年平均气温25.4℃，气候温和，林地面积2.07万公顷，森林覆盖率达84.2％，是三亚最大的“绿色银行”。近年来已成功引种榴莲、紫色释迦果、彩虹西瓜、芒果菠萝、泰国青柚等“新奇特优”品种，种植面积突破17000亩。育才生态区以榴莲产业为核心，榴莲种植面积已达15000亩，建成全国首座榴莲加工厂，构建了榴莲种植、加工、文旅、科研全产业链，致力于打造国内领先的榴莲产业融合发展示范区，创建了“中国榴莲在三亚，三亚榴莲在育才”的特色品牌。未来还将建设榴莲国际交流中心，搭建全球榴莲产业技术、贸易、文化交流平台，并配套专业科研场所，为榴莲品种改良、种植技术提升与产品研发提供核心科技支撑，打造集产业中枢、文化IP、农旅体验于一体的三产融合项目。
                         <span className="inDevelopment-text__body--text__t">(二) 现代物流仓储</span>根据《三亚市育才生态区立才片区连队村庄规划（2021－2035）场域国土空间综合规划》，区内已规划物流仓储用地2块。可依托现有芒果、凤梨、榴莲等农业产业基础，建设集生产、加工、运输为一体的现代物流仓储中心。
                         <span className="inDevelopment-text__body--text__t">(三) 生态康养</span>育才生态区负氧离子全年平均值达3300个/cm³，最高可达10000个/cm³，是天然“森林氧吧”。在医疗配套方面，育才医院新院区按二级综合医院标准建设，总建筑面积约20865.5平方米，设置床位170余张。医院设有妇产科、儿科、眼科、康复科、重症监护、手术区等科室。怡人的生态环境，结合丰富的医疗资源及三亚护理职业学院培养的数千名专业护理人员储备，均可为生态康养产业提供坚实的要素保障。
                         <span className="inDevelopment-text__body--text__t">(四) 户外休闲旅游</span>育才生态区分布有南塔瀑布、抱安溶洞、雅亮村百年芒果园、那受村500年古荔枝树、马脚村船型屋等自然人文景观，全域旅游资源丰富。随着环热带雨林国家公园旅游公路的贯通，区域旅游开发潜力已全面释放，现计划引进徒步、马拉松、骑行、射击等各类专业运动赛事及户外生态体验基地、露营基地等项目，打造集休闲娱乐与健康养生于一体的产业集群。
                         <span className="inDevelopment-text__body--text__t">(五) 和美乡村建设</span>依托那受、龙密、马亮、雅亮等美丽乡村建设，围绕“宜居宜业”目标，重点开发乡村民宿、户外营地、农耕体验等乡村振兴项目。通过改善农村生态与景观，打造一批知名的农产品品牌，建设特色IP产业乐园，助力农村生态旅游发展，带动农民收入增加。现已建成龙密户外营地、且慢山舍等项目，在建有那受国际艺谷公共服务中心项目。
                         <span className="inDevelopment-text__body--text__t">(六) 新能源产业</span>育才生态区全年日照时长约2563小时，光照资源丰富，具备太阳能、风能等良好条件。在清洁能源开发方面，已与华能等央企等达成良好合作。
                         <span className="inDevelopment-text__body--text__t">(七) 教育研学</span>育才生态区现有公办学校13所，其中十二年一贯制学校1所，九年一贯制学校1所，完全小学6所，幼儿园５所。引进了三亚护理职业学院、三亚航空旅游职业学院新校区、三亚正德学校、龙密国际教育基地等优质教育研学资源。其中，三亚护理职业学院、三亚航空旅游职业学院新校区、三亚正德学校均为海南省重点项目。
                    </p>
                </div>
            </div>
            <div className="inDevelopment-pic">
                <img className="inDevelopment-pic__img" src={gaikuoditu} alt="ooo"></img>
            </div>
        </div>
    );
}

export default InDevelopment;
